export default class FiltersRedirect {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        // If the View All option is selected on the Events filter, clear the current url and redirect to the #events section
        if (window.location.pathname === '/events/' && window.location.search === '?category%5B%5D=') {
            window.location.href = '/events#events';
        }

        // If the View All option is selected on the News filter, clear the current url and redirect to the #news section
        if (window.location.pathname === '/latest-news/' && window.location.search === '?category%5B%5D=') {
            window.location.href = '/latest-news#news';
        }

    }

};

new FiltersRedirect();